import { useState } from "react";
import { Sparkles, Send, Truck, Route, Clock } from "lucide-react";
import { rootConverse } from "@/lib/rootConsole";

const clock = (ms) => (ms ? new Date(ms).toISOString().replace("T", " ").slice(0, 19) : null);

// Command Bar TULUSS — TOUJOURS visible et contextuelle. Injecte le contexte sélectionné
// (décision / véhicule / mission / instant T) dans le message pour que TULUSS ne reparte pas de zéro.
export default function CommandBar({ context, onAuthError }) {
  const [msg, setMsg] = useState("");
  const [log, setLog] = useState([]);
  const [busy, setBusy] = useState(false);

  const ctx = context || {};
  const preamble = () => {
    const bits = [];
    if (ctx.decisionId) bits.push(`décision=${ctx.decisionId}`);
    if (ctx.vehicleName) bits.push(`véhicule=${ctx.vehicleName}`);
    if (ctx.missionId) bits.push(`mission=${ctx.missionId}`);
    if (ctx.tMs) bits.push(`instant=${clock(ctx.tMs)}`);
    if (ctx.mode === "lab") bits.push("mode=LABORATOIRE(DJ Mixer)");
    if (ctx.experimentId) bits.push(`expérimentation=${ctx.experimentId}`);
    return bits.length ? `[Contexte cockpit sélectionné: ${bits.join(", ")}]\n` : "";
  };

  const send = async () => {
    const text = msg.trim();
    if (!text || busy) return;
    setLog((l) => [...l, { who: "f", txt: text }]);
    setMsg(""); setBusy(true);
    try {
      const r = await rootConverse(preamble() + text);
      setLog((l) => [...l, { who: "t", txt: r.reply + (r.challenge?.has_conflict ? " [conflit détecté]" : "") }]);
    } catch (e) {
      const st = e?.response?.status;
      if ((st === 401 || st === 403) && onAuthError) { onAuthError(); return; }
      setLog((l) => [...l, { who: "t", txt: "Erreur : " + (e?.response?.data?.detail || String(e)) }]);
    } finally { setBusy(false); }
  };

  return (
    <footer className="cmdbar" data-testid="ck-commandbar">
      {log.length > 0 && (
        <div className="cmdbar__log" data-testid="cmdbar-log">
          {log.slice(-6).map((m, i) => (
            <div key={i} className="cmdbar__msg">
              <b className={m.who === "t" ? "who-t" : "who-f"}>{m.who === "t" ? "TULUSS" : "Founder"} :</b> {m.txt}
            </div>
          ))}
        </div>
      )}
      <div className="cmdbar__row">
        <Sparkles size={18} style={{ color: "#a78bfa" }} />
        <div className="cmdbar__ctx" data-testid="cmdbar-context">
          {ctx.vehicleName && <span className="ctx-chip"><Truck size={11} />{ctx.vehicleName}</span>}
          {ctx.missionId && <span className="ctx-chip"><Route size={11} />{String(ctx.missionId).slice(-8)}</span>}
          {ctx.decisionId && <span className="ctx-chip">◈ {String(ctx.decisionId).slice(-8)}</span>}
          {ctx.tMs && <span className="ctx-chip"><Clock size={11} />{clock(ctx.tMs)?.slice(11)}</span>}
        </div>
        <input className="cmdbar__input" placeholder={ctx.decisionId ? "Demande à TULUSS (ex: « Pourquoi ce choix ? »)" : "Parle à TULUSS — le contexte sélectionné est transmis automatiquement"}
          value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
          data-testid="cmdbar-input" />
        <button className="cmdbar__send" onClick={send} disabled={busy} data-testid="cmdbar-send">
          <Send size={13} style={{ verticalAlign: "-1px", marginRight: 5 }} />{busy ? "…" : "Envoyer"}
        </button>
      </div>
    </footer>
  );
}
